import { render } from "./OptionsDropdown.vue?vue&type=template&id=04842a2e&scoped=true"
import script from "./OptionsDropdown.vue?vue&type=script&lang=js"
export * from "./OptionsDropdown.vue?vue&type=script&lang=js"

import "./OptionsDropdown.vue?vue&type=style&index=0&id=04842a2e&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04842a2e"]])

export default __exports__